import { FC, ReactElement, useMemo } from 'react';
import { IAllBranchesModalItem } from '../../../AllBranchesModal/AllBranchesModal';
import { IBranchesModalItem } from '../../BranchesModal';
import { BranchesModalHeaderControls } from '../../components/BranchesModalHeaderControls/BranchesModalHeaderControls';
import { BranchesModalHeaderSearch } from '../../components/BranchesModalHeaderSearch/BranchesModalHeaderSearch';
import Crumbs from '~/view/components/Controls/Crumbs';
import { MODALS_CRUMB } from 'src/types/main';
import { localeStore } from 'src/mobx/localesStore';

interface IProps {
  searchValue: string;
  activeCrumb: MODALS_CRUMB;
  selectedBranches?: IBranchesModalItem[] | IAllBranchesModalItem[];
  onSearch: (value: string) => void;
  clickCrumb: (value: MODALS_CRUMB) => void;
  selectAll: () => void;
  deselectAll: () => void;
  loading: boolean;
  isMulti: boolean;
  isAll?: boolean;
  selectedItemsLength: number;
  hideMultiSelectButtons?: boolean;
  hideSelectAllButtonWhenSearch?: boolean;
  hideSelectAllButton?: boolean;
  hideDeselectAllButton?: boolean;
}

export const BranchesModalHeader: FC<IProps> = (props: IProps): ReactElement => {
  const selectedCrumbTitle = useMemo((): string => {
    const selectedBranchesNumber: number | null = props.isMulti && (props.selectedItemsLength || props.isAll) ? props.selectedItemsLength : null;

    return localeStore.t('selected') + ' (' + (props.isAll ? localeStore.t('all') : String(selectedBranchesNumber || 0)) + ')';
  }, [props.isAll, props.isMulti, props.selectedItemsLength]);

  const crumbs = useMemo(() => {
    return [
      { label: localeStore.t('all'), value: MODALS_CRUMB.ALL },
      { label: selectedCrumbTitle, value: MODALS_CRUMB.SELECTED },
    ];
  }, [selectedCrumbTitle]);

  if (props.isMulti && props.hideMultiSelectButtons) {
    return (
      <div className="custom-modal-header">
        <BranchesModalHeaderSearch loading={props.loading} searchValue={props.searchValue} onSearch={props.onSearch} />
      </div>
    );
  }

  if (props.isMulti) {
    return (
      <div className="custom-modal-header">
        <BranchesModalHeaderSearch loading={props.loading} searchValue={props.searchValue} onSearch={props.onSearch} />

        <div className="d-flex flex-row justify-content-between mt-4">
          <Crumbs crumbs={crumbs} activeCrumb={props.activeCrumb} onClick={props.clickCrumb} />
          <BranchesModalHeaderControls
            searchValue={props.searchValue}
            selectedBranches={props.selectedBranches}
            selectAll={props.selectAll}
            deselectAll={props.deselectAll}
            isMulti={props.isMulti}
            hideSelectAllButtonWhenSearch={props.hideSelectAllButtonWhenSearch}
            hideSelectAllButton={props.hideSelectAllButton}
            hideDeselectAllButton={props.hideDeselectAllButton}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="custom-modal-header">
      <div className="d-flex flex-row align-items-bottom justify-content-between">
        <BranchesModalHeaderSearch loading={props.loading} searchValue={props.searchValue} onSearch={props.onSearch} />
        <BranchesModalHeaderControls
          searchValue={props.searchValue}
          selectedBranches={props.selectedBranches}
          selectAll={props.selectAll}
          deselectAll={props.deselectAll}
          isMulti={props.isMulti}
          hideSelectAllButtonWhenSearch={props.hideSelectAllButtonWhenSearch}
          hideSelectAllButton={props.hideSelectAllButton}
          hideDeselectAllButton={props.hideDeselectAllButton}
        />
      </div>
    </div>
  );
};
